<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-shifoudengl`]" width="1em" height="1em" v-bind="$attrs"><path d="M44.1155728,78.3378371 L52.8888814,87.1111562 L83.9999323,56.0000677 L52.8888814,24.8889791 L44.1155728,33.6622982 L60.1688205,49.7778229 L0.000135342525,49.7778229 L0.000135342525,62.2223125 L60.1689558,62.2223125 L44.1155728,78.3378371 Z M99.5555255,0 L12.4444745,0 C5.53781011,0 0,5.5999391 0,12.4444896 L0,37.3333333 L12.4444745,37.3333333 L12.4444745,12.4444896 L99.5553901,12.4444896 L99.5553901,99.5555104 L12.4444745,99.5555104 L12.4444745,74.6666667 L0,74.6666667 L0,99.5555104 C0,106.399926 5.53794545,112 12.4446099,112 L99.5555255,112 C106.399932,112 112,106.400061 112,99.5555104 L112,12.4444896 C112,5.60007444 106.399932,0 99.5555255,0 Z" transform="translate(9 9)" :fill="useCurrentColor ? 'currentColor' : '#4E5969'" fill-rule="nonzero"/></svg>
</template>
<script>

export default {
  name: 'IconPsmShifoudengl',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
